/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetPlanInfoDetailRequest
 */
export interface RequestGetPlanInfoDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoDetailRequest
     */
    baseId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoDetailRequest
     */
    planId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoDetailRequest
     */
    statusId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoDetailRequest
     */
    tenantId: number;
}

/**
 * Check if a given object implements the RequestGetPlanInfoDetailRequest interface.
 */
export function instanceOfRequestGetPlanInfoDetailRequest(value: object): value is RequestGetPlanInfoDetailRequest {
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function RequestGetPlanInfoDetailRequestFromJSON(json: any): RequestGetPlanInfoDetailRequest {
    return RequestGetPlanInfoDetailRequestFromJSONTyped(json, false);
}

export function RequestGetPlanInfoDetailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetPlanInfoDetailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'planId': json['plan_id'] == null ? undefined : json['plan_id'],
        'statusId': json['status_id'],
        'tenantId': json['tenant_id'],
    };
}

export function RequestGetPlanInfoDetailRequestToJSON(json: any): RequestGetPlanInfoDetailRequest {
    return RequestGetPlanInfoDetailRequestToJSONTyped(json, false);
}

export function RequestGetPlanInfoDetailRequestToJSONTyped(value?: RequestGetPlanInfoDetailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'plan_id': value['planId'],
        'status_id': value['statusId'],
        'tenant_id': value['tenantId'],
    };
}

